import React from "react";
import {AlertTriangle} from "lucide-react";

export const Uad36Alert: React.FC = () => (
    <div className="mb-6 bg-red-50 border border-red-200 rounded-md p-4 flex justify-between items-center">
        <div className="flex items-center space-x-2">
            <AlertTriangle className="h-5 w-5 text-red-500"/>
            <h3 className="font-medium text-red-800">Alert</h3>
        </div>
        <span className="font-medium text-red-800">
            This Report Must Comply with UAD 3.6
        </span>
    </div>
);

interface Uad36PageProps {
    uad36: boolean;
    label: string;
    children: React.ReactNode;
}

// page container for order and quote details; the band's negative margins cancel this padding
export const Uad36Page: React.FC<Uad36PageProps> = ({uad36, label, children}) => (
    <div className={`max-w-7xl mx-auto px-4 py-6 ${uad36 ? "rounded-xl bg-cyan-50/60 ring-1 ring-cyan-200" : ""}`}>
        {uad36 && (
            <div className="-mx-4 -mt-6 mb-6 bg-cyan-100/70 px-4 py-2 rounded-t-xl">
                <p className="text-xs font-semibold uppercase tracking-wide text-cyan-900">
                    {label}
                </p>
            </div>
        )}
        {children}
    </div>
);
